import { motion } from "framer-motion";
import ContactCTA from "../About/ContactCTA";
import NewsletterCTA from "../About/NewsletterCTA";
export default function SupportHero({ onOpenTicket }) {
  return (
    <>
      <section className="overflow-hidden relative py-24 bg-gradient-to-b from-emerald-50 via-emerald-50 to-white">
        <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full blur-3xl bg-emerald-300/20" />
        <div className="absolute bottom-0 -right-20 w-72 h-72 rounded-full blur-3xl bg-emerald-200/30" />

        <div className="relative px-6 mx-auto max-w-6xl text-center">
          <motion.h1
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
          >
            We’re here to help
          </motion.h1>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-gray-700">
          Reach out to us through any of these channels. We're here to help you with all your issues 
          </p>
          <ContactCTA />

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.4 }}
            className="flex gap-3 justify-center items-center mt-6"
          >
            {/* <button
              onClick={onOpenTicket}
              className="px-6 py-3 text-sm font-semibold text-white bg-emerald-600 rounded-xl shadow-sm transition hover:bg-emerald-500"
            >
              Submit a Ticket
            </button> */}
            <button onClick={() => window.open('https://wa.me/233204014370', '_blank')} className="px-6 py-3 text-sm font-semibold text-emerald-700 bg-white rounded-xl ring-1 transition ring-emerald-600/30 hover:bg-emerald-50">
              WhatsApp Us
            </button>
          </motion.div>
        </div>
      </section>

      <div className="py-10">
        <NewsletterCTA />
      </div>
    </>
  );
}
